import styled from 'styled-components';
import { Row } from 'react-bootstrap';

export const TableContainer = styled.div`
  overflow-x: auto;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
`;

export const Table = styled.table`
  width: 100%;
  margin-bottom: 0;
`;

export const TableRow = styled.tr`
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const TableCell = styled.td`
  vertical-align: middle;
  padding: 0.75rem;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const FilterCard = styled.div`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const FilterRow = styled(Row)`
  margin-bottom: 0.5rem;
`;
